
/**
 * State needed both by the router and the App to decide whether we're ready to
 * show certain parts of the UI.
 */
export interface AppRoutingState {
  /**
   * Specifies wheter parts of the UI that depend on a pre-initialized Vuex
   * store be shown.
   *
   * TODO: Get rid of the concept of pre-initialization of the Vuex store, and
   * get rid of the Vuex store in its entirety.
   */
  storeInitialized: boolean;
}

export function makeAppRoutingState(): AppRoutingState {
  return {
    storeInitialized: false
  };
}
